import useSWR from "swr"
import {API_URL} from "../constants/apiUrls"

export default function useTeamLexiconItems(teamLexiconId) {
    const {data, mutate, error} = useSWR(`${API_URL}/lexicons/${teamLexiconId}/items`)
    return {
        teamLexiconItems: data,
        mutateTeamLexiconItems: mutate,
        isLoadingTeamLexiconItems: !error && !data,
        isErrorTeamLexiconItems: error
    }
}